module.exports = __webpack_public_path__ + "assets/img/bg-hero.3013c0d156661bdb25efc385b6c2eaaf.svg";